export default "__VITE_ASSET__BBHptcNJ__"